// convert JS date to string like "Saturday May 1, 2020"
export default function dateToString(
  date: Date,
  showDay: boolean = true
): string {
  const day = date.getDay()
  const dateOfMonth = date.getDate()
  const month = date.getMonth()
  const year = date.getFullYear()
  const dayNames = [
    `Sunday`,
    `Monday`,
    `Tuesday`,
    `Wednesday`,
    `Thursday`,
    `Friday`,
    `Saturday`,
  ]
  const monthNames = [
    `Jan.`,
    `Feb.`,
    `March`,
    `April`,
    `May`,
    `June`,
    `July`,
    `Aug.`,
    `Sept.`,
    `Oct.`,
    `Nov.`,
    `Dec.`,
  ]
  return showDay
    ? `${dayNames[day]}, ${monthNames[month]} ${dateOfMonth}, ${year}`
    : `${monthNames[month]} ${dateOfMonth}, ${year}`
}
